import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import SectionHeader from '../SectionHeader/SectionHeader';
import { headerWithDescType } from 'src/types';

function BlockWithImageAndCta({ image, link, sectionHeader: { title, tagline, description } }) {
  return (
    <Container as="section" fluid className="bg-gray-800 py-5">
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col xs={12} lg={5}>
            <GatsbyImage className="fade-in-lottie" alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />;
          </Col>
          <Col xs={12} lg={{ span: 6, offset: 1 }} className="my-5">
            <SectionHeader title={title} tagline={tagline} description={description} isDark textAlign="text-left">
              <Link className="btn-link-secondary" key={link._key} to={link.url}>
                {link.title}
              </Link>
            </SectionHeader>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

BlockWithImageAndCta.propTypes = {
  image: PropTypes.shape({}).isRequired,
  link: PropTypes.shape({}).isRequired,
  sectionHeader: headerWithDescType.propTypes,
};

BlockWithImageAndCta.defaultProps = {
  sectionHeader: headerWithDescType.defaultProps,
};

export default BlockWithImageAndCta;
